// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3LTvT","body":"body___2hFOR","subtitle":"subtitle___Kmsn3","horizontal":"horizontal___2weSC","image":"image___2PY85"};